import { EmptyResults, SearchParameters, SearchResults } from '../../models';
import { getSearchResults } from './get-search-results';

type ANCType = '1' | '2' | '3' | '4';

export const getProductsByANCType = async (
  ancType: ANCType
): Promise<SearchResults | EmptyResults> => {
  const searchParameters: SearchParameters = {
    productSearchFilter: `attributes/any(a: a eq 'Product_AncTypePublicWeb|${ancType}')`,
    searchQuery: '',
    skip: 0,
    numberOfResultsPerPage: 10,
    locale: 'en-us',
    orderBy: 'discountedPrice desc',
  };
  const response = await getSearchResults(searchParameters);
  return response;
};
